<template>
    <div>
        <h1>Which of these topics are you interested in?</h1>

        <p>Pick as many as you want.</p>

        <b-alert variant="danger" :show="isError" class="mb-5">Sorry, it looks like something went wrong. Please try again.</b-alert>

        <div class="form-group row">
            <div class="col-12" v-for="courseType in courseTypes" v-bind:key="courseType.id">
                <div class="custom-control custom-checkbox">
                    <input :id="'courseType'+ courseType.id" type="checkbox" class="custom-control-input" v-model="user.courseTypes" :value="courseType.id" :disabled="isBusy">
                    <label :for="'courseType'+ courseType.id" class="custom-control-label">
                        {{ courseType.name }}
                    </label>
                </div>
            </div>
        </div>
        <button class="btn btn-primary mt-3" :disabled="isBusy" @click="saveOnboarding">Next</button>
    </div>
</template>

<script>
    export default {
        props: {
        },

        data() {
            return {
                user: {
                    courseTypes: [], 
                },
                courseTypes: [],
                isSuccess: false,
                isBusy: false,
                isError: false,
            }
        },

        mounted() {
            this.getCourseTypes();
        },

        methods: {
            // Save
            saveOnboarding() {
                this.isBusy = true;

                axios.post('/api/me/update', {
                    'user': this.user
                }).then((response) => {
                    this.isBusy = false;

                    Bus.$emit('stepComplete', {
                        'step': 'courseTypes'
                    });
                }).catch((e) => {
                    this.isBusy = false;
                    this.isError = true;
                });
            },

            // Get all genres
            getCourseTypes() {
                this.isBusy = true;

                axios.get('/api/me/course-types').then((response) => {
                    this.courseTypes = response.data.courseTypes;
                    this.user.courseTypes = response.data.selectedCourseTypes;
                    this.isBusy = false;
                });
            },
        }
    }
</script>